<template>
  <Dialog
    ref="dialog"
    title="温馨提示"
    :is-init-show="false"
    :is-show-footer="false"
  >
    <div class="delete-detail">
      {{ tipsInfo }}
    </div>
  </Dialog>
</template>

<script>
import Dialog from '@components/dialog/dialog'
export default {
  name: 'DeleteDialog',
  components: {
    Dialog
  },
  props: {
    tipsInfo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style lang='scss' scoped>
/deep/ .el-dialog {
  width: 326px !important;
  height: 179px !important;
  background: #FFFFFF;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  .el-dialog__header {
    padding: 18px 30px 35px;
  }
}
.delete-detail {
  text-align: center;
  color: #424242;
  font-size: 16px;
}
</style>
